import React from 'react';
import EnqChat from '../EnqChat';
// import WcaEnqChat from '../WcaEnqChat';
import { useSelector } from 'react-redux';
import TrailDashboard from '../TrailDashboard';

const ChatEnq = () => {
  const { userSub, companyConfigData } = useSelector((state) => state.authenticate);
  if (!userSub?.isUserSub) {
    return <TrailDashboard />;
  }

  return <EnqChat />;
  // return companyConfigData?.wabaPartner === 'skalebot' ? <WcaEnqChat /> : <EnqChat />;
};

export default ChatEnq;
